<template lang="pug">
#edit-pathway
      .container
        input(type="text" v-model="editPathway.name" placeholder="Pathway Name").pathway-name
        .upload
          p.label {{ editPathway.pdfURL ? 'Edit' : 'Upload' }} PDF
          .pdf-wrapper
            .uploading-status(v-if="isUploading")
              .loading-circles
                span
                span
                span
            pdf(
              v-else-if="editPathway.pdfURL"
              :src="editPathway.pdfURL"
              :key="editPathway.pdfURL"
            )
            b.no-pdf(v-else) No PDF Preview
          label.upload-button(:for='"chooseFile"') Choose a File
          input(:id='"chooseFile"' type='file' accept="application/pdf" @change='uploadPDF($event.target.files[0])' ref='fileInput')

        .single-col-school-toggle(v-if="schools.length == 1")
              label(v-for="school in schools")
                  input(
                      type="checkbox"
                      @click="toggleSchoolOffered( school )"
                      :checked='school.pathways[editPathway.id].provides'
                      )
                  | {{ school.name }}

        .two-col-school-toggle(v-else)
          .left
            label(v-for="school in schools.slice(0, 5)")
              input(
                  type="checkbox"
                  @click="toggleSchoolOffered( school )"
                  :checked='school.pathways[editPathway.id].provides'
                  )
              | {{ school.name }}
          .right
            label(v-for="school in schools.slice(5)")
              input(
                  type="checkbox"
                  @click="toggleSchoolOffered( school )"
                  :checked='school.pathways[editPathway.id].provides'
                  )
              | {{ school.name }}
</template>

<script>
import { Ref, firebase } from '@/lib/db';
import debounce from 'debounce';
import pdf from 'vue-pdf';

export default {
  name       : 'edit-pathway',
  components : {
    pdf
  },
  props : {
    editPathway : Object,
  },
  data() {
    return {
      isUploading       : false,
      delayedTextUpdate : debounce( this.updatePathwayName, 1000 ),
    };
  },
  computed : {
    isAdmin() {
      return this.$store.state.isAdmin;
    },

    schools() {
      const { schools, setSchool } = this.$store.getters;
      if ( setSchool == 'All' ) return schools;
      return schools.filter( school => school.id == setSchool );
    },

    currentSchool() {
      return this.$store.getters.currentSchool;
    },
  },

  methods : {
    uploadPDF( file ) {
      this.isUploading = true;
      const upload = firebase.storage().ref( `ctePathways/${this.editPathway.id}/` ).put( file );
      return upload
        .then( snapshot => snapshot.ref.getDownloadURL() )
        .then( ( url ) => {
          this.editPathway.pdfURL = url;
          Ref.child( `ctePathways/${this.editPathway.id}/pdfURL` ).set( url );
          this.isUploading = false;
        } );
    },

    async toggleSchoolOffered( school ) {
      //  Checked --> Unchecked
      if ( this.editPathway.schools[school.name].provides ) {
        school.pathways[this.editPathway.id].provides = false;

        // Check if the pathway we unchecked was the last pathway under its' industrySector.
        const { ctePathways } = this.$store.getters;
        const stillOfferSector = Object.keys( school.pathways ).filter( ( pathway ) => {
					  const ctePathway = ctePathways.find( p => p.id === pathway );
					  return (
					    ctePathway.industrySector === this.editPathway.industrySector
							&& school.pathways[pathway].provides
					  );
        } ).length > 0;
        if ( !stillOfferSector ) {
          await Ref.child( 'schools' )
            .child( `${school.name}/industrySectors/${this.editPathway.industrySector}` )
            .set( { provides : false } );
        }

        // Update the database.
        await Promise.all( [
          Ref.child( 'ctePathways' )
            .child( `${this.editPathway.id}/schools/${school.name}` )
            .set( { provides : false } ),
          Ref.child( 'schools' )
            .child( `${school.name}/pathways/${this.editPathway.id}` )
            .set( { provides : false } ),
        ] );
      }
      // Unchecked --> Checked:
      else {
        this.editPathway.schools[school.name].provides = true;

        // Update the database.
        await Promise.all( [
          Ref.child( 'ctePathways' )
            .child( `${this.editPathway.id}/schools/${school.name}` )
            .set( { provides : true } ),
          Ref.child( 'schools' )
            .child( `${school.name}/pathways/${this.editPathway.id}` )
            .set( { provides : true } ),
          Ref.child( 'schools' )
            .child( `${school.name}/industrySectors/${this.editPathway.industrySector}` )
            .set( { provides : true } ),
        ] );
      }
    },

    updatePathwayName() {
      Ref.child( `ctePathways/${this.editPathway.id}/name` ).set( this.editPathway.name );
    },
  },

  watch : {
    editPathway : {
      handler() {
        this.delayedTextUpdate();
      },
      deep : true,
    },
  },
};
</script>

<style lang="scss">
#edit-pathway {
	display: flex;
	flex-direction: column;
	align-items: center;

	.file-preview {
		height: 183px;
	}

  .pathway-name {
    color: black;
    border: $primary 1px solid;
    width: 75%;
    height: 2rem;
  }

	.container {
		display: flex;
		flex-direction: column;
		gap: 25px;
		align-items: center;
	}

	.single-col-school-toggle {
		display: flex;
		flex-direction: column;
		align-items: left;
	}

	.two-col-school-toggle {
		display: flex;
		flex-direction: row;
		gap: 50px;
		.left,
		.right {
			display: flex;
			flex-direction: column;
			align-items: left;
		}
	}

	.upload {
    border: #4d6ea2 dashed 1px;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		align-items: center;


    .uploading-status {
	  margin-top: 100px;
	  margin-bottom: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .pdf-wrapper{
      width: 550px;
      height: 100%;
    }

    .no-pdf  {
      width: 550px;
      height: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }

		p.label {
			color: $primary;
			font-size: 18px;
			font-weight: 600;
		}

    input {
      display: none;
    }

    label.upload-button  {
      font-family: "Work Sans", sans-serif;
      background-color: #4d6ea2;
      border: none;
      color: white;
      padding: 10px 15px;
      border-radius: 5px;
      transition: opacity 0.2s ease;
      margin-bottom: 5px;
      cursor: pointer;
    }
    }
}
</style>
